import { Middleware } from '@reduxjs/toolkit';
import { cleanExpiredMessages } from '@reducers/v2/messagesBus/messagesBus.slice';
import { appVisibilityService } from '@services/appVisibility';

const CLEANUP_INTERVAL = 10 * 60 * 1000; // 10 minutes

let cleanupTimer: ReturnType<typeof setInterval> | null = null;

export const messagesBusCleanupMiddleware: Middleware = (store) => {
  const startCleanup = (): void => {
    if (cleanupTimer) return;
    cleanupTimer = setInterval(() => {
      store.dispatch(cleanExpiredMessages());
    }, CLEANUP_INTERVAL);
  };

  const stopCleanup = (): void => {
    if (cleanupTimer) {
      clearInterval(cleanupTimer);
      cleanupTimer = null;
    }
  };

  startCleanup();

  appVisibilityService.subscribe((isVisible) => {
    if (isVisible) {
      // Clean immediately on return, then resume interval
      store.dispatch(cleanExpiredMessages());
      startCleanup();
    } else {
      stopCleanup();
    }
  });

  return (next) => (action) => next(action);
};
